import React from 'react';
import { Segment, Dimmer, Loader } from 'semantic-ui-react';
import { colors, radius } from '../styles/globalStyles';

/**
 * 全局加载动画组件（深色风格）
 * 统一的加载状态展示样式
 */
const Loading = ({ prompt: name = 'page' }) => {
  return (
    <Segment
      style={{
        height: 200,
        borderRadius: radius.lg,
        border: `1px solid ${colors.border}`,
        background: 'rgba(0,0,0,0.02)',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
      }}
    >
      <Dimmer active>
        <Loader indeterminate size='large' style={{ color: colors.primaryLight }}>加载{name}中...</Loader>
      </Dimmer>
    </Segment>
  );
};

export default Loading;
